import React, { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import { ResponseInterface } from './response-interface';
import styles from './styles.module.scss';

interface Props {
  responseList: ResponseInterface[];
}

const PromptResponseList: FC<Props> = ({ responseList }) => {
  return (
    <div>
      {responseList.map(responseData => (
        <div
          className={
            styles.container +
            ' ' +
            (responseData.isSelf ? styles.myQuestion : 'chatgpt-response')
          }
          key={responseData.id}
        >
          <img
            className={styles.avatar}
            src={
              responseData.isSelf
                ? '/images/avatars/me.png'
                : '/images/avatars/chatgpt.png'
            }
            alt="avatar"
          />
          <div>
            <div id={responseData.id} />
            {responseData.response && (
              <ReactMarkdown
                children={responseData.response}
                components={{
                  code({ className, children }) {
                    return <code className={className}>{children}</code>;
                  },
                }}
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PromptResponseList;
